import { render, staticRenderFns } from "./PersonalRobberyConcernedPersonQuestion.vue?vue&type=template&id=2e2f410e&scoped=true"
import script from "./PersonalRobberyConcernedPersonQuestion.vue?vue&type=script&lang=ts"
export * from "./PersonalRobberyConcernedPersonQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f410e",
  null
  
)

export default component.exports